export default __webpack_public_path__ + "static/PPGoshaSans-Bold-683e3cc47b053403992ed638ac216b95.otf";